module.exports = __webpack_public_path__ + "img/pro_11.97dad8b0.jpg";